import React, { useState } from "react";
import FA from "../../containers/fa";
import FullLessonViewModal from "./FullLessonViewModal";

// Book-open action button + tri-state lesson-view modal, fully self-contained so
// each class row can drop in <LessonViewControl cls={cls} /> without the parent
// tracking per-class state. `cls` is a UserTag-shaped object; its
// `enable_full_lesson_view` (null | true | false) seeds the initial value.
//
//   true  -> All Lessons (green)
//   false -> Recommended Only (dark grey)
//   null  -> inherit school/global default (muted grey)
const colorForValue = (v) =>
  v === true ? "#28a745" : v === false ? "#4B4B4B" : "#b0b0b0";

const LessonViewControl = ({ cls, orgValue, className = "btn btn-small" }) => {
  const initial =
    cls.enable_full_lesson_view === undefined
      ? null
      : cls.enable_full_lesson_view;
  const [value, setValue] = useState(initial);
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        aria-label='Lesson View'
        data-title='Lesson View'
        className={className}
        style={{ backgroundColor: "transparent" }}
        onClick={() => setOpen(true)}
      >
        <FA icon='book-open' color={colorForValue(value)} />
      </button>

      {open && (
        <FullLessonViewModal
          clsId={cls.id}
          initialValue={value}
          orgValue={orgValue}
          onClose={() => setOpen(false)}
          onSaved={(id, val) => setValue(val)}
        />
      )}
    </>
  );
};

export default LessonViewControl;
